import * as React from "react";

import TwitterIcon from "./TwitterIcon";
import GitHubIcon from "./GitHubIcon";
import FacebookIcon from "./FacebookIcon";
import TelegramIcon from "./TelegramIcon";
import RedditIcon from "./RedditIcon";

interface FooterProps {
	style?: any;
	onInfoClick: any;
}

const Footer = (props: FooterProps) => (
	<div
		style={{
			display: "flex",
			alignItems: "center",
			height: "2rem",
			backgroundColor: "#7B97A3",
			color: "#fff",
			fontSize: 16,
			zIndex: 100,
			...(props.style || {}),
		}}
	>
		<span
			style={{
				marginLeft: "1.61rem",
				fontFamily: "Rajdhani",
			}}
		>
			&copy;{new Date().getFullYear()} BLOCKv
		</span>

		<div
			style={{
				display: "flex",
				alignItems: "center",
				marginTop: 5, // note: the images do appear vertically centered, but they seem to be off by a little... this fixes it
				marginLeft: "1.61rem",
				flex: 1,
			}}
		>
			<a href="https://twitter.com/blockv_io" target="_blank">
				<TwitterIcon
					style={{
						height: 20,
						margin: 0,
					}}
					iconColor={(props.style || {}).color || "#fff"}
				/>
			</a>
			<a href="https://github.com/blockvio" target="_blank">
				<GitHubIcon
					style={{
						height: 20,
						margin: 0,
					}}
					iconColor={(props.style || {}).color || "#fff"}
				/>
			</a>
			<a href="https://facebook.com/blockvio" target="_blank">
				<FacebookIcon
					style={{
						height: 20,
						margin: 0,
					}}
					iconColor={(props.style || {}).color || "#fff"}
				/>
			</a>
			<a href="https://t.me/block_v" target="_blank">
				<TelegramIcon
					style={{
						height: 20,
						margin: 0,
					}}
					iconColor={(props.style || {}).color || "#fff"}
				/>
			</a>
			<a href="https://reddit.com/r/blockv" target="_blank">
				<RedditIcon
					style={{
						height: 20,
						margin: 0,
					}}
					iconColor={(props.style || {}).color || "#fff"}
				/>
			</a>
		</div>

		<div
			style={{
				display: "flex",
				alignItems: "center",
				marginTop: 5, // note: the images do appear vertically centered, but they seem to be off by a little... this fixes it
				marginRight: "1.61rem",
			}}
		>
			<span
				style={{
					fontSize: 10,
					color: "#8aaab7",
					marginBottom: 5,
					cursor: "pointer",
				}}
				onClick={props.onInfoClick}
			>
				Info
			</span>
		</div>
	</div>
);

export default Footer;



// WEBPACK FOOTER //
// ./src/components/Footer/Footer.tsx